import { useEffect, useState } from 'react';
import discountService from '../../_services/discount.service';

/**
 * The salon's rule for selling below the menu price (beu-node-v2
 * discount/manualDiscount.js): 'log' (the default: it is recorded for
 * Reports › Manual Discounts) or 'refuse' (staff whose role has no Discounts
 * can't lower a price on someone else's sale). One fetch per location; any
 * failure reads as 'log', which is what the server does without the setting.
 */
const cache = {};

export function loadManualRule(force) {
  const salonId = String(localStorage.getItem('salonId') || '');
  if (!force && cache[salonId]) return cache[salonId];
  cache[salonId] = discountService.manualRule()
    .then((r) => (r && r.rule === 'refuse' ? 'refuse' : 'log'))
    .catch(() => 'log');
  return cache[salonId];
}

export function setCachedManualRule(rule) {
  const salonId = String(localStorage.getItem('salonId') || '');
  cache[salonId] = Promise.resolve(rule === 'refuse' ? 'refuse' : 'log');
}

export function useManualRule() {
  const [rule, setRule] = useState('log');
  useEffect(() => {
    let live = true;
    loadManualRule().then((r) => { if (live) setRule(r); });
    return () => { live = false; };
  }, []);
  return rule;
}
